// eslint-disable-next-line no-unused-vars
import czlStorage from "@/utils/czStorage.js";
import { setToken } from "@/utils/auth.js";
import { getMenueByName } from "@/utils/tools.js";
import { login } from "@/api/user";
import { routes } from "@/router/data";
import { sidebar } from "@/utils/common.js";
import {setUserId, setUsername} from "../../utils/auth";
const system = {
  namespaced: true,
  state: {
    sidebar: sidebar,
    chioseRouter: null,
    isLogin: !czlStorage.get("token"), //是否弹出
    token: "",
    searchIconEvent: null,
    userInfo: { username: czlStorage.get("username") },
    fullScreen: false,
    device: "desktop",
    terminalType: 'PC'
  },
  mutations: {
    SET_TERMINALTYPE:(state,typeName) => {
      state.terminalType = typeName
    },
    TOGGLE_SIDEBAR: (state, obj) => {
      state.chioseRouter = obj;
    },
    LOGIN: (state, token) => {
      state.isLogin = false;
      state.token = token;
      setToken(token);
    },
    LOGOUT: state => {
      state.token = null;
      state.isLogin = true;
      setToken(null);
    },
    CLOSE_FULLDIALG: (state, flag) => {
      state.fullScreen = flag;
    },
    SET_USERINFO: (state, obj) => {
      state.userInfo = obj;
      setUserId(obj.memberId)
      setUsername(obj.username)
    },
    SET_SEARCHICONENENT: (state, enevt) => {
      state.searchIconEvent = enevt;
    }
  },
  actions: {
    GetTerminalTyle:({ commit },typeName) => {
      commit("SET_TERMINALTYPE",typeName)
    },
    ToggleSideBar: ({ commit }) => {
      commit("TOGGLE_SIDEBAR");
    },
    CloseSideBar({ commit }, obj) {
      let temp = getMenueByName(routes,obj)
      // eslint-disable-next-line no-console
      console.log(temp);
      commit("TOGGLE_SIDEBAR", temp);
    },
    logout({ commit }) {
      commit("LOGOUT");
    },
    // eslint-disable-next-line no-unused-vars
    async login({ dispatch, commit, state }, obj) {
      let data = await login(obj.userName, obj.passwd);
      commit("LOGIN", data.data.token);
      commit("SET_USERINFO", data.data);
    },
    ToggleDevice({ commit }, device) {
      commit("TOGGLE_DEVICE", device);
    },
    takeFullScreen({ commit }, flag) {
      commit("CLOSE_FULLDIALG", flag);
    },
    setSearchIconEvent({ commit }, event) {
      commit("SET_SEARCHICONENENT", event);
    }
  }
};

export default system;
